import qs from 'qs';

export { URL } from '~/renderer/utils/help-urls';

export const staticPath = '../static';

export const isClientSideReady = () => typeof window !== 'undefined';

export const isWindows = isClientSideReady() && navigator.platform.indexOf('Win') > -1;

export const isRenderProcess = !!(isClientSideReady() && window.ipcRenderer);

export const isBrowserCFD = isClientSideReady() && !window.ipcRenderer;

export const isCustomerCFD =
  isBrowserCFD && window.location.search.includes('channelNameCustomer=');

export const { channelNameCustomer = undefined } = isCustomerCFD
  ? qs.parse(window.location.search, { ignoreQueryPrefix: true })
  : {};

export const DEFAULT_BACKGROUND_IMAGE =
  'https://res.cloudinary.com/lightspeed-retail/image/upload/b-clothing1-new.jpg';

export const TEST_IMAGE = 'lightspeed-logo.png';

export const TEST_IMAGE_PATH = `${staticPath}/assets/${TEST_IMAGE}`;

export const generateRandomString = (
  length: number = 0,
  possible: string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
) =>
  Array.from(Array(length)).reduce(
    result => result + possible.charAt(Math.floor(Math.random() * possible.length)),
    '',
  );

export const getBrowserLocale = () => {
  let browserLocale;

  if (navigator.languages && navigator.languages.length) {
    // latest versions of Chrome and Firefox set this correctly
    [browserLocale] = navigator.languages;
  } else {
    // latest versions of Chrome, Firefox, and Safari set this correctly
    browserLocale = navigator.language;
  }

  return browserLocale;
};
